var _path, _circle, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDestination(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5217 37.3066C19.7353 33.3885 23.6516 30.7559 26.9359 27.6794C30.0525 24.7599 32 20.6074 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 20.6074 1.94745 24.7599 5.06412 27.6794C8.34841 30.7559 12.2647 33.3885 14.4783 37.3066L15.5647 39.2295C15.7561 39.5682 16.2439 39.5682 16.4353 39.2295L17.5217 37.3066Z",
    fill: "#4B4B4B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 14,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9626 11.9122C26.863 11.5128 26.564 11.3132 26.1653 11.2133L19.7871 10.3148L16.8969 4.52415C16.598 3.82528 15.402 3.82528 15.1031 4.52415L12.2129 10.2149L5.93431 11.2133C5.53567 11.2133 5.23669 11.5128 5.03737 11.9122C4.93771 12.3115 5.03737 12.7109 5.33635 12.9106L9.92072 17.4033L8.82446 23.7929C8.7248 24.1923 8.92412 24.5916 9.2231 24.7913C9.52208 24.991 9.92072 25.0908 10.3194 24.8912L16 21.896L21.6806 24.8912C21.88 24.8912 21.9796 24.8912 22.1789 24.8912C22.3783 24.8912 22.5776 24.7913 22.7769 24.6915C23.0759 24.4918 23.2752 24.0925 23.1755 23.6931L22.0793 17.3035L26.6636 12.8107C26.9626 12.6111 27.0623 12.2117 26.9626 11.9122Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_56_52344",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 22,
    height: 21
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9626 11.9122C26.863 11.5128 26.564 11.3132 26.1653 11.2133L19.7871 10.3148L16.8969 4.52415C16.598 3.82528 15.402 3.82528 15.1031 4.52415L12.2129 10.2149L5.93431 11.2133C5.53567 11.2133 5.23669 11.5128 5.03737 11.9122C4.93771 12.3115 5.03737 12.7109 5.33635 12.9106L9.92072 17.4033L8.82446 23.7929C8.7248 24.1923 8.92412 24.5916 9.2231 24.7913C9.52208 24.991 9.92072 25.0908 10.3194 24.8912L16 21.896L21.6806 24.8912C21.88 24.8912 21.9796 24.8912 22.1789 24.8912C22.3783 24.8912 22.5776 24.7913 22.7769 24.6915C23.0759 24.4918 23.2752 24.0925 23.1755 23.6931L22.0793 17.3035L26.6636 12.8107C26.9626 12.6111 27.0623 12.2117 26.9626 11.9122Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_56_52344)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 24,
    height: 24,
    fill: "#4B4B4B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDestination);
export default __webpack_public_path__ + "static/media/icon_destination.2542bc16ef7a83bb1ea1039564a5ecb3.svg";
export { ForwardRef as ReactComponent };